import React from "react";

import Button from "@mui/material/Button";

import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import "../shared/header.css";
import "../step.css";

function LeadsStep6(props) {
    const history = useNavigate();
    const language = useSelector((state) => state.languagesState.languages);

    const pushUserToTrackePage = () => {
        history("/lead-connections");
    };

    return (
        <div
            className="col-sm-12 leads-wizard-complete"
            data-cy="lead-wizard-success"
        >
            <div className="wizard-complete-area">
                <div className="wizard-complete-area-image">
                    <img src="/assets/images/signal-sight.png"></img>
                </div>
                <div className="wizard-complete-area-text">
                    <h3>
                        {language?.lead_wizard?.congratulations ??
                            "Congratulations"}
                        ,
                    </h3>
                    <h4>
                        <b>{props?.connectionName}</b>{" "}
                        {language?.lead_wizard?.has_been_created ??
                            "has been created."}
                    </h4>
                </div>
                <div className="wizard-complete-area-button">
                    <Button
                        data-cy="lead-wizard-success-continue"
                        onClick={pushUserToTrackePage}
                        type="button"
                        variant="contained"
                        color="primary"
                    >
                        {language?.lead_wizard?.continue ?? "CONTINUE"}
                    </Button>
                </div>
            </div>
        </div>
    );
}

export default LeadsStep6;
